// Identité du binaire installé, en un seul endroit.
//
// Pourquoi : jusqu'au 17.08.2026 tous les builds preview sortaient en
// « 1.0.0 / build 7 », et le mail « Signaler un bug » annonçait un 1.0.0 écrit
// en dur. Résultat : ni le testeur ni nous ne pouvions dire quelle version
// était installée, et une remarque portant sur un build périmé s'est retrouvée
// traitée comme un bug ouvert.
//
// Trois informations complémentaires :
//  - version marketing (1.0.0) : app.config.js ;
//  - numéro de build natif : résolu par EAS au moment du build
//    (appVersionSource 'remote' + autoIncrement sur le profil preview), donc
//    il n'existe PAS dans app.config.js — il faut le lire dans le binaire, ce
//    que fait expo-application ;
//  - commit : injecté dans extra.build par app.config.js, seul moyen de
//    remonter au code exact.

import * as Application from 'expo-application';
import Constants from 'expo-constants';

interface BuildExtra {
  commit?: string;
  profile?: string;
}

function buildExtra(): BuildExtra {
  return (Constants.expoConfig?.extra?.build as BuildExtra) ?? {};
}

/** Version marketing, ex. « 1.0.0 ». */
export function getAppVersion(): string {
  return (
    Application.nativeApplicationVersion ??
    Constants.expoConfig?.version ??
    '1.0.0'
  );
}

/** Numéro de build natif, ex. « 14 ». '?' hors binaire natif (web, Expo Go). */
export function getBuildNumber(): string {
  return Application.nativeBuildVersion ?? '?';
}

/** Commit court du build, ex. « 9f82a18 ». */
export function getBuildCommit(): string {
  return buildExtra().commit ?? 'unknown';
}

/**
 * Libellé complet, ex. « 1.0.0 (14) · 9f82a18 ». C'est CETTE chaîne qu'il faut
 * demander à un testeur : elle identifie le binaire sans ambiguïté.
 */
export function getAppVersionLabel(): string {
  const profile = buildExtra().profile;
  const suffix = profile && profile !== 'production' ? ` · ${profile}` : '';
  return `${getAppVersion()} (${getBuildNumber()}) · ${getBuildCommit()}${suffix}`;
}
